import {
  LayoutDashboard,
  Edit,
  BarChart,
  LineChart,
  Wrench,
  MessageSquare,
  Settings,
  User,
  List,
  AlertTriangle,
  Trash,
  Mail,
  Bell,
  FileWarning,
  Building2,
  Users,
  Hammer,
  Search,
  Tags,
  BookOpen,
  BarChart2,
  ClipboardCheck,
  Building,
  Activity,
  Map,
  FileText,
  FileDown,
} from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";

export interface ILeftMenuMenuProps {
  to: string;
  icon: string;
  translationKey: string;
}

export const LeftMenuLinkItem: React.FunctionComponent<ILeftMenuMenuProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`leftMenu.${key}`);
  const location = useLocation();

  const { to, icon, translationKey } = props;

  const isActive = location.pathname === to;

  const renderIcon = () => {
    const iconColor = isActive ? "#FFFFFF" : "#3241FF";
    const iconProps = {
      size: 20,
      color: iconColor,
      strokeWidth: 2,
    };

    switch (icon) {
      case "icon-dashboard":
        return <LayoutDashboard {...iconProps} />;
      case "icon-mass-post":
        return <Edit {...iconProps} />;
      case "icon-chart":
        return <BarChart {...iconProps} />;
      case "icon-line-chart":
        return <LineChart {...iconProps} />;
      case "icon-build":
        return <Building {...iconProps} />;
      case "icon-suggestions":
        return <MessageSquare {...iconProps} />;
      case "icon-setting":
        return <Settings {...iconProps} />;
      case "icon-user-circle":
        return <User {...iconProps} />;
      case "icon-list":
        return <List {...iconProps} />;
      case "icon-warning":
        return <AlertTriangle {...iconProps} />;
      case "icon-alert":
        return <Bell {...iconProps} />;
      case "icon-error-logs":
        return <FileWarning {...iconProps} />;
      case "icon-trash":
        return <Trash {...iconProps} />;
      case "icon-email":
        return <Mail {...iconProps} />;
      case "icon-locations":
        return <Building2 {...iconProps} />;
      case "icon-organizations":
        return <Users {...iconProps} />;
      case "icon-function-management":
        return <Hammer {...iconProps} />;
      case "icon-internal-tools":
        return <Wrench {...iconProps} />;
      case "icon-find-user":
        return <Search {...iconProps} />;
      case "icon-internal-labels":
        return <Tags {...iconProps} />;
      case "icon-custom-reviews":
        return <BookOpen {...iconProps} />;
      case "icon-analysis":
        return <BarChart2 {...iconProps} />;
      case "icon-recommendations":
        return <ClipboardCheck {...iconProps} />;
      case "icon-facility-list":
        return <Building {...iconProps} />;
      case "icon-location-activity":
        return <Activity {...iconProps} />;
      case "icon-integration":
        return <Map {...iconProps} />;
      case "icon-rec-messages":
        return <FileText {...iconProps} />;
      case "icon-data-download":
        return <FileDown {...iconProps} />;
      default:
        return null;
    }
  };

  return (
    <li>
      <NavLink to={to} exact className={`nav-items`} activeClassName="active">
        <div className="icons lucide-icon">
          {renderIcon() || <i className={`icons ${icon}`}></i>}
        </div>
        <span className="txt">{t(translationKey)}</span>
      </NavLink>
    </li>
  );
};
